import { Trans } from 'react-i18next';
import i18n from 'i18next';
import t from '../translate';

export const RISK_BREAKDOWNS = {
  BREACH_HISTORY: 'breach_history',
  TARGETING_LEVEL: 'targeting_level',
  EXPOSURE: 'exposure',
  HYGIENE: 'hygiene'
};

export const FUSIONS = {
  KNOWN_BREACH_HISTORY: 'known_breach_history',
  SECURITY_NEWS_FEED: 'security_news_feed',
  EXPOSED_EMPLOYEE_CREDENTIALS: 'exposed_employee_credentials',
  CHATTER_IN_SPECIFIC_FORUMS: 'chatter_in_specific_forums',
  VERIFIED_BREACHES: 'verified_breaches',
  RANSOMWARE_GROUPS_PORTALS: 'ransomware_groups_portals',
  EMPLOYEE_CREDS_OFFERED_FOR_SALE: 'employee_creds_offered_for_sale',
  PHISHING_CAMPAIGNS: 'phishing_campaigns',
  EXPLOITABLE_PORTS: 'exploitable_ports',
  HIJACKABLE_SUBDOMAINS: 'hijackable_subdomains',
  OPEN_WEB_INTERFACE: 'open_web_interface',
  SEVERE_SSL_TLS_ISSUES: 'severe_ssl_tls_issues',
  MAIL_SERVERS_IN_BLOCKLIST: 'mail_servers_in_blocklist',
  SSL_TLS_ISSUES: 'ssl_tls_issues',
  EMAIL_SECURITY_ISSUES: 'email_security_issues',
  CERTIFICATE_AUTHORITY_ISSUES: 'certificate_authority_issues',
  WEB_APP_SECURITY: 'web_app_security'
};

export const ASM_ISSUE_KEYS = {
  OPEN_PORTS: 'open_ports',
  OPEN_WEB_INTERFACE: 'open_web_interface',
  HIJACKABLE_DNS: 'hijackable_dns',
  TLS_OUTDATED_VERSION_SSL_SUPPORTED: 'tls.outdated_version_ssl_supported',
  TLS_SERVER_HAS_KNOWN_VULNERABILITY: 'tls.server_has_known_vulnerability',
  TLS_SERVER_ACCEPTS_INSECURE_RENEGOTIATION: 'tls.server_accepts_insecure_renegotiation',
  TLS_OUTDATED_VERSION_TLS_SUPPORTED: 'tls.outdated_version_tls_supported',
  TLS_SERVER_SUPPORTS_ONE_ELLIPTIC_CURVE: 'tls.server_supports_one_elliptic_curve',
  TLS_SOME_CIPHERS_DONT_SUPPORT_FORWARD_SECRECY: 'tls.some_ciphers_dont_support_forward_secrecy',
  TLS_SERVER_DOES_NOT_SUPPORT_TLS_1_3: 'tls.server_does_not_support_tls_1_3',
  TLS_WEAK_CIPHER_SUITES: 'tls.weak_cipher_suites',
  TLS_INSECURE_CIPHER_SUITES: 'tls.insecure_cipher_suites',
  DMARC_MISSING: 'dmarc.dmarc_missing',
  DMARC_MISCONFIGURED: 'dmarc.dmarc_misconfigured',
  DMARC_WEAK: 'dmarc.dmarc_weak',
  DMARC_UNMONITORED: 'dmarc.dmarc_unmonitored',
  DMARC_MULTIPLE_RECORDS: 'dmarc.dmarc_multiple_records',
  DMARC_UNVALIDATED: 'dmarc.dmarc_unvalidated',
  SPF_MISCONFIGURED: 'spf.spf_misconfigured',
  SPF_MISSING: 'spf.spf_missing',
  SPF_MULTIPLE_RECORDS: 'spf.spf_multiple_records',
  SPF_WEAK: 'spf.spf_weak',
  CAA_MISSING: 'caa.missing',
  CAA_MISCONFIGURED: 'caa.misconfigured',
  CAA_UNMONITORED: 'caa.unmonitored',
  WEB_APP_SECURITY_MISSING_HSTS_HEADER: 'web_app_security.missing_hsts_header_detected',
  WEB_APP_SECURITY_MISCONFIGURED_HSTS_HEADER: 'web_app_security.misconfigured_hsts_header_detected',
  WEB_APP_SECURITY_MISSING_X_FRAME_OPTIONS_HEADER: 'web_app_security.missing_x_frame_options_header_detected',
  WEB_APP_SECURITY_MISCONFIGURED_X_FRAME_OPTIONS_HEADER:
    'web_app_security.misconfigured_x_frame_options_header_detected',
  WEB_APP_SECURITY_MISSING_X_CONTENT_TYPE_OPTIONS_HEADER:
    'web_app_security.missing_x_content_type_options_header_detected',
  WEB_APP_SECURITY_MISCONFIGURED_X_CONTENT_TYPE_OPTIONS_HEADER:
    'web_app_security.misconfigured_x_content_type_options_header_detected',
  WEB_APP_SECURITY_MISSING_CONTENT_SECURITY_POLICY_HEADER:
    'web_app_security.missing_content_security_policy_header_detected',
  WEB_APP_SECURITY_MISSING_REFERRER_POLICY_HEADER: 'web_app_security.missing_referrer_policy_header_detected',
  WEB_APP_SECURITY_MISSING_X_PERMITTED_CROSS_DOMAIN_POLICIES_HEADER:
    'web_app_security.missing_x_permitted_cross_domain_policies_header_detected'
};

export const SCORE_WEIGHT = {
  VERY_HIGH: 'veryHigh',
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low'
};

export const SCORE_WEIGHT_RANGE = [SCORE_WEIGHT.LOW, SCORE_WEIGHT.MEDIUM, SCORE_WEIGHT.HIGH, SCORE_WEIGHT.VERY_HIGH];

const buildContentObject = (categoryType, scoreWeight) => ({
  transComponent: (
    <Trans
      i18nKey="supplyChain.categoryTooltip"
      values={{ scoreWeight: i18n.t(`supplyChain.${scoreWeight}`), categoryType }}
    />
  ),
  scoreWeight
});

export const TOOLTIP_CONTENT = {
  [RISK_BREAKDOWNS.BREACH_HISTORY]: {
    getContent: categoryType => buildContentObject(categoryType, SCORE_WEIGHT.VERY_HIGH)
  },
  [RISK_BREAKDOWNS.TARGETING_LEVEL]: {
    getContent: categoryType => buildContentObject(categoryType, SCORE_WEIGHT.MEDIUM)
  },
  [RISK_BREAKDOWNS.EXPOSURE]: {
    getContent: categoryType => buildContentObject(categoryType, SCORE_WEIGHT.MEDIUM)
  },
  [RISK_BREAKDOWNS.HYGIENE]: {
    getContent: categoryType => buildContentObject(categoryType, SCORE_WEIGHT.LOW)
  },
  [FUSIONS.KNOWN_BREACH_HISTORY]: 'known_breach_history',
  [FUSIONS.SECURITY_NEWS_FEED]: 'security_news_feed',
  [FUSIONS.EXPOSED_EMPLOYEE_CREDENTIALS]: 'exposed_employee_credentials',
  [FUSIONS.CHATTER_IN_SPECIFIC_FORUMS]: 'chatter_in_specific_forums',
  [FUSIONS.VERIFIED_BREACHES]: 'verified_breaches',
  [FUSIONS.RANSOMWARE_GROUPS_PORTALS]: 'ransomware_groups_portals',
  [FUSIONS.EMPLOYEE_CREDS_OFFERED_FOR_SALE]: 'employee_creds_offered_for_sale',
  [FUSIONS.PHISHING_CAMPAIGNS]: 'phishing_campaigns',
  [FUSIONS.EXPLOITABLE_PORTS]: 'exploitable_ports',
  [FUSIONS.HIJACKABLE_SUBDOMAINS]: 'hijackable_subdomains',
  [FUSIONS.SEVERE_SSL_TLS_ISSUES]: 'severe_ssl_tls_issues',
  [FUSIONS.OPEN_WEB_INTERFACE]: 'open_web_interface',
  [FUSIONS.MAIL_SERVERS_IN_BLOCKLIST]: 'mail_servers_in_blocklist',
  [FUSIONS.SSL_TLS_ISSUES]: 'ssl_tls_issues',
  [FUSIONS.EMAIL_SECURITY_ISSUES]: 'email_security_issues',
  [FUSIONS.CERTIFICATE_AUTHORITY_ISSUES]: 'certificate_authority_issues'
};

export const RISK_FACTORS_WITH_PRECEDENCE = {
  recently_attacked: 1,
  recently_breached: 1,
  exposed_credentials: 3,
  // TODO - to be added in later stage
  // employee_creds_offered_for_sale: 3,
  crime_chatter: 4,
  phishing_campaign: 4,
  exploitable_ports: 5,
  open_web_interface: 5,
  hijackable_subdomains: 6,
  ssl_tls_issues: 7,
  email_security_issues: 7,
  certificate_authority_issues: 7
};

export const RISK_FACTORS_OPTIONS = Object.keys(RISK_FACTORS_WITH_PRECEDENCE).map(value => ({
  value,
  label: t(`risk_factors.${value}`)
}));
